<ng-container [formGroup]="form">
    <fieldset 
        class="_flex"
        [ngClass]="modifierClassname">
        <div class="_flex _items-center _self-start">
            <input 
                [formControlName]="groupName"
                [id]="fieldId"
                [attr.name]="groupName"
                class="_radio-btn"
                type="radio"
                [value]="value"
                [checked]="checked">
                <label [for]="fieldId" class="_cursor-pointer _ml-1 _text-md">
                    <ng-content></ng-content>
                </label>
            </div> 
    </fieldset>
</ng-container>

